import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    HStack,
    Spacer,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import { useRef } from 'react';

export function ConfirmBookingTimeout({
    confirmTimeOutDisclosure,
    handleClose,
    handleContinueBooking,
}: {
    confirmTimeOutDisclosure: ReturnType<typeof useDisclosure>;
    handleClose: () => void;
    handleContinueBooking: () => void;
}) {
    const cancelBookingRef = useRef<HTMLButtonElement | null>(null);

    return (
        <AlertDialog
            isOpen={confirmTimeOutDisclosure.isOpen}
            onClose={confirmTimeOutDisclosure.onClose}
            leastDestructiveRef={cancelBookingRef}
            motionPreset="slideInBottom"
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Your booking time has expired
                    </AlertDialogHeader>
                    <AlertDialogBody>
                        <Text>
                            Your booking time has expired.
                            You will need to select a time slot again.
                            Do you want to continue with the booking?
                        </Text>
                    </AlertDialogBody>
                    <AlertDialogFooter pt={6}>
                        <HStack w="full">
                            <Button size="md" variant="ghost" colorScheme="muted" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Spacer />
                            <Button onClick={handleContinueBooking} size="md" ml={3} variant="solid" colorScheme="secondary">
                                Continue
                            </Button>
                        </HStack>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
}
